export default __webpack_public_path__ + "static/media/facebook-footer-preview.5624076d.png";